import React from 'react';
import Icon, { ICONS, COLORS } from '../../../general-components/icon';
import { VirtualBg } from '../../../../stores/types/content';
import * as l from './elements';
import { POP_TYPE } from './effects';

interface OwnProps {
	onPopover: (e: React.MouseEvent, type: POP_TYPE, uniqueId?: string, url?: string) => void,
	onSelect: (background: VirtualBg) => void,
	bg: VirtualBg,
	type: POP_TYPE,
	active: boolean
}

export default function VbgCardImg(props: OwnProps) {
	const {
		bg,
		type,
		active,
		onSelect,
		onPopover,
	} = props;

	return (
		<l.Card>
			<img
				className={active ? 'selected' : ''}
				src={bg.thumbnail ?? bg.url ?? ''}
				onMouseUp={(e) => {
					e.preventDefault();
					e.stopPropagation();
					onSelect(bg);
				}}
			/>
			<l.SelectedOverlay hidden={!active} />
			{
				type !== POP_TYPE.DEFAULT && <l.EllipsesContainer
					className='popover-parent'
					onClick={(e) => onPopover(e, type, bg.uniqueId, bg.url)}
				>
					<Icon name={ICONS.THREE_DOTS_HORIZONTAL} size={24} color={COLORS.LIGHT_GRAY} />
				</l.EllipsesContainer>
			}
		</l.Card>
	);
}
